// NIGHT-DIRECTSTAFF-2026-10-25d §3: the full thread on a lead / candidate -- every SMS / chat message on their conversations (agent,
// them, staff, system told apart) with the CRM's own lines inline where they happened: re-engagement steps, instant-match texts
// (agent_lead_decisions 'instant_match'), voicemails and missed calls, weekly summaries, logged calls. Search within it; jump to a day.
const s = (v) => (v === null || v === undefined ? '' : String(v).trim());
const t = (iso) => { const x = Date.parse(iso || ''); return Number.isNaN(x) ? null : x; };
export const WHO = { candidate: 'them', user: 'them', agent: 'agent', assistant: 'agent', human: 'staff', system: 'system' };
export const WHO_LABEL = { them: 'Them', agent: 'Agent', staff: 'Staff', system: 'System', note: 'CRM' };
const INLINE = { reengage: 'Re-engagement', voicemail: 'Voicemail', missed_call: 'Missed call', summary: 'Weekly summary', call_log: 'Call logged', call_followup: 'Call back' };

/** messages (agent_messages), activity rows (this person's), decisions (this lead's) -> [{ key, at, who, text }] oldest first */
export function threadItems({ messages = [], activity = [], decisions = [] } = {}) {
  const out = [];
  for (const m of messages || []) {
    const who = WHO[s(m.role)] || 'system';
    out.push({ key: `m-${m.id || m.created_at}`, at: m.created_at, who, text: s(m.body) || (who === 'system' ? s(m.note) : ''), status: m.status || null });
  }
  for (const a of activity || []) {
    const label = INLINE[s(a.type)];
    if (!label) continue;
    out.push({ key: `a-${a.id || a.created_at}`, at: a.created_at || a.date, who: 'note', text: `${label}: ${s(a.note).replace(/ · lead_id=[0-9a-f-]{36}\s*$/i, '').replace(/\s*\n\s*/g, ' · ')}` });
  }
  for (const d of decisions || []) {
    if (s(d.decision) !== 'instant_match') continue;
    out.push({ key: `d-${d.id || d.created_at}`, at: d.created_at, who: 'note', text: `Instant match texted: job ${s(d.reason) || 'posting'}` });
  }
  return out.filter((x) => t(x.at) !== null).sort((a, b) => t(a.at) - t(b.at));
}
/** the items a search keeps (every word, any case); '' -> all */
export function searchThread(items, q) {
  const words = s(q).toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return items;
  return items.filter((x) => words.every((w) => x.text.toLowerCase().includes(w)));
}
/** the first item on or after a day ('YYYY-MM-DD', Eastern) -> its key | null */
export function firstOnOrAfter(items, day) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(s(day))) return null;
  const hit = items.find((x) => new Date(x.at).toLocaleDateString('en-CA', { timeZone: 'America/New_York' }) >= day);
  return hit ? hit.key : null;
}

// NIGHT-DIRECTSTAFF-2026-10-28b §2: the Thread draws the newest PAGE lines; "Show earlier" adds a page.
export const PAGE = 50;
/** items (oldest first), how many to draw -> { visible: the newest `limit`, hidden: how many older are not drawn } */
export function pageOf(items, limit = PAGE) {
  const n = Math.max(0, Math.min(items.length, limit));
  return { visible: n === items.length ? items : items.slice(items.length - n), hidden: items.length - n };
}
